import { Event as GlobalEvent } from "../../../Global/Base/Events";
import { IDisposable } from "../../../Global/Base/IDisposable";
import { IBaseAction } from "../Actions/IAction";

export interface IDropDownMenuItem extends HTMLElement, IDisposable {
    icon: string;
    priority: number;
    action: IBaseAction;
    parent: IDropDownMenu;
    isOpened?: boolean;
}

export class IDropDownMenuItem {
    private static _properties: (keyof IDropDownMenuItem)[] = ["icon", "priority", "action", "parent"];
    private static _methods: (keyof IDropDownMenuItem)[] = [];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function") &&
            instance instanceof HTMLElement;
    }
}

export interface IDropDownMenuItemWithSubmenu extends IDropDownMenuItem {
    isClickable: boolean;
    submenu: IDropDownMenu;
}

export interface IDropDownMenu extends IDisposable {
    onClose: GlobalEvent<IDropDownMenu, any>;
    rootMenu: IDropDownMenu;
    openedSubmenu: IDropDownMenu;
    /** Zabrání vytvoření časovače pro automatické zavření menu */
    disableCloseTimeout: boolean;
    /** Časovač, po jehož vypršení dojde k automatickému zavření menu */
    closeTimeout: number;
    lastSelectedItem: IDropDownMenuItem;

    visible: boolean;
    hasPrimaryAction: boolean;

    removeItem(item: IDropDownMenuItem): void;
    addItemAfter(itemToAdd: IDropDownMenuItem, existingItem: IDropDownMenuItem): void;
    addItem(item: IDropDownMenuItem): void;
    clearItems(): void;
    show(startElement: HTMLElement | IDropDownMenuItem, event: Event): void;
    close(): void;
    closeAll(dontOpenOnNextClick?: boolean, focusLastOpenedTarget?: boolean): void;
    recalculatePosition(): void;
    orientation: Orientation;
}

export enum Orientation {
    horizontal,
    vertical,
}

export enum DropDownMenuHorizontalOpen {
    left,
    right,
    center,
}

export enum DropDownMenuVerticalOpen {
    top,
    bottom,
    middle,
}
